import appUrl, { appLinks, appName, imageUrl, ogUrl } from '@libs/appUrl'
import config from '@public-config'
import Head from 'next/head'

import { useAmp } from 'next/amp'
import { useRouter } from 'next/router'

const JSONLD_DATA_WEBSITE = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url: 'https://www.popdaily.com.tw/',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.popdaily.com.tw/search/{search_term_string}',
    'query-input': 'required name=search_term_string',
  },
}

const JSONLD_DATA_ORGANIZATION = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  legalName: 'PopDaily 波波黛莉的異想世界 - 台灣',
  url: 'https://www.popdaily.com.tw',
  logo: 'https://static.popdaily.com.tw/statics/images/popdaily-logo.svg',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+886-2-87730883',
    contactType: 'customer service',
    areaServed: 'TW',
    availableLanguage: ['Chinese'],
  },
  sameAs: [
    'https://www.facebook.com/PopDailyTW/',
    'https://www.youtube.com/channel/UCa40JCy-ESpqENGHBmml7KA',
    'https://www.instagram.com/popdaily/',
  ],
}

const AD_PUSHUP = `
(function(w, d) {
          var s = d.createElement('script');
          s.src = '//cdn.adpushup.com/48029/adpushup.js';
          s.crossOrigin='anonymous'; 
          s.type = 'text/javascript'; s.async = true;
          (d.getElementsByTagName('head')[0] || d.getElementsByTagName('body')[0]).appendChild(s);
          w.adpushup = w.adpushup || {que:[]};
        })(window, document);
`

function DefaultHead(props) {
  const { isApp } = props
  const router = useRouter()
  const isAmp = useAmp()

  const isCanonicalPath = () => {
    const paths = [
      '/',
      '/explore/[clas]',
      '/[website]',
      '/[website]/[postID]',
      '/forum/[forum]/[postID]',
      '/map',
      '/place/[placeId]',
    ]
    return paths.includes(router.pathname)
  }

  const canonicalHref = `${appUrl.hostUrl}${router.asPath}`
  const isTagPage = router.route.includes('/tag/')

  return (
    <Head>
      {isCanonicalPath() && <link key="canonical" rel="canonical" href={canonicalHref} />}
      <link rel="dns-prefetch" href={appUrl.hostUrl} />
      <link rel="dns-prefetch" href={appUrl.imageBaseUrl} />
      <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      <link rel="shortcut icon" href={imageUrl('/statics/favicons/202105favicon.png')} />
      <title key="title">PopDaily 波波黛莉的異想世界</title>
      {!isAmp && (
        <meta
          key="viewport"
          name="viewport"
          content={`initial-scale=1.0, width=device-width, maximum-scale=1.0, user-scalable=${
            isApp ? 0 : 1
          }, viewport-fit=cover`}
        />
      )}
      {/* 電商要幫 Agoda 聯盟行銷，驗證網域用的  */}
      <meta name="agd-partner-manual-verification" />
      <meta
        name="ahrefs-site-verification"
        content="f9bc7122d9782937c96d6d0beddc55335a624889c645eef2263008fad2f10275"
      />
      <meta key="charset" charSet="utf-8" />
      <meta key="theme-color" name="theme-color" content="#ffffff" />
      <meta key="application-name" name="application-name" content="PopDaily" />
      {/* gliacloud:meta:data */}
      <meta name="dailymotion-domain-verification" content="dm4evxpwmstww0lxf" />
      {/* og:meta:data */}
      <meta key="og:url" property="og:url" content={ogUrl(router.asPath)} />
      <meta key="og:site_name" property="og:site_name" content="PopDaily" />
      <meta key="og:locale" property="og:locale" content="zh_TW" />
      <meta key="fb:app_id" property="fb:app_id" content={config.fbAppId} />
      <meta key="al:ios:app_name" property="al:ios:app_name" content={appName} />
      <meta key="al:ios:app_store_id" property="al:ios:app_store_id" content="1410055224" />
      <meta key="al:ios:url" property="al:ios:url" content={appLinks(router.asPath)} />
      <meta key="al:android:app_name" property="al:android:app_name" content={appName} />
      <meta key="al:android:package" property="al:android:package" content="com.popdaily" />
      <meta key="al:web:should_fallback" property="al:web:should_fallback" content="true" />
      <meta
        key="description"
        name="description"
        content="PopDaily 波波黛莉的異想世界，女孩的吃喝玩樂、購物生活都在這：）"
      />
      <meta key="og:type" property="og:type" content="website" />
      <meta key="og:title" property="og:title" content="PopDaily 波波黛莉的異想世界" />
      <meta
        key="og:description"
        property="og:description"
        content="PopDaily 波波黛莉的異想世界，女孩的吃喝玩樂、購物生活都在這：）"
      />
      <meta key="og:image" property="og:image" content={imageUrl('/statics/images/og.jpg')} />
      <meta key="og:image:width" property="og:image:width" content="1560" />
      <meta key="og:image:height" property="og:image:height" content="820" />
      <meta key="twitter:title" property="twitter:title" content="PopDaily 波波黛莉的異想世界" />
      <meta
        key="twitter:description"
        property="twitter:description"
        content="PopDaily 波波黛莉的異想世界，女孩的吃喝玩樂、購物生活都在這：）"
      />
      <meta
        key="twitter:image"
        property="twitter:image"
        content={imageUrl('/statics/images/og.jpg')}
      />
      {/* async google web-font Noto Sans */}
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css?family=Roboto:400,500,700&display=swap"
        media="print"
        onLoad="this.media='all'"
      />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css?family=Noto+Sans:400,700&display=swap"
        media="print"
        onLoad="this.media='all'"
      />
      {/* ld+json */}
      {!isTagPage && (
        <script
          key="JSONLD_DATA_WEBSITE"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(JSONLD_DATA_WEBSITE) }}
        />
      )}

      <script
        key="JSONLD_DATA_ORGANIZATION"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(JSONLD_DATA_ORGANIZATION) }}
      />

      <script
        data-cfasync="false"
        type="text/javascript"
        dangerouslySetInnerHTML={{ __html: AD_PUSHUP }}
      />
      <link rel="stylesheet" type="text/css" href="https://static.dable.io/dist/exit-dialog.css" />
      {!isAmp && (
        <script
          dangerouslySetInnerHTML={{
            __html: `
              (function() {
                const script = document.createElement('script');
                script.setAttribute('id', 'YrblBvsA');
                script.setAttribute('data-sdk', 'l/1.1.11');
                script.setAttribute('data-cfasync', 'false');
                script.setAttribute('src', 'https://html-load.com/loader.min.js');
                script.setAttribute('charset', 'UTF-8');
                script.setAttribute('data', 'vkds2ucpkck5k9kspkipnjwv052028jokfpkskcrj28ksg2828kckfp5kcrkj28okfpkc28kgkcf2ckskskfp2gnfjwv02gp2iko');
                script.setAttribute('onload', "!async function(){let e='html-load.com';const t=window,r=e=>new Promise((t=>setTimeout(t,e))),o=t.atob,a=t.btoa,s=r=>{const s=o('VGhlcmUgd2FzIGEgcHJvYmxlbSBsb2FkaW5nIHRoZSBwYWdlLiBQbGVhc2UgY2xpY2sgT0sgdG8gbGVhcm4gbW9yZS4=');if(confirm(s)){const o=new t.URL('https://report.error-report.com/modal'),s=o.searchParams;s.set('url',a(location.href)),s.set('error',a(r.toString())),s.set('domain',e),location.href=o.href}else location.reload()};try{const c=()=>new Promise((e=>{let r=Math.random().toString(),o=Math.random().toString();t.addEventListener('message',(e=>e.data===r&&t.postMessage(o,'*'))),t.addEventListener('message',(t=>t.data===o&&e())),t.postMessage(r,'*')}));async function n(){try{let e=!1,o=Math.random().toString();if(t.addEventListener('message',(t=>{t.data===o+'_as_res'&&(e=!0)})),t.postMessage(o+'_as_req','*'),await c(),await r(500),e)return!0}catch(e){console.error(e)}return!1}const i=[100,500,1e3];for(let l=0;l<=i.length&&!await n();l++){if(l===i.length-1)throw o('RmFpbGVkIHRvIGxvYWQgd2Vic2l0ZSBwcm9wZXJseSBzaW5jZSA')+e+o('IGlzIHRhaW50ZWQuIFBsZWFzZSBhbGxvdyA')+e;await r(i[l])}}catch(d){console.error(d);try{t.localStorage.setItem(t.location.host+'_fa_'+a('last_bfa_at'),Date.now().toString())}catch(m){}try{setInterval((()=>document.querySelectorAll('link,style').forEach((e=>e.remove()))),100);const h=await(await fetch('https://error-report.com/report?type=loader_light&url='+a(location.href)+'&error='+a(d),{method:'POST'})).text();let g=!1;t.addEventListener('message',(e=>{'as_modal_loaded'===e.data&&(g=!0)}));let p=document.createElement('iframe');const f=new t.URL('https://report.error-report.com/modal'),u=f.searchParams;u.set('url',a(location.href)),u.set('eventId',h),u.set('error',a(d)),u.set('domain',e),p.src=f.href,p.setAttribute('style','width:100vw;height:100vh;z-index:2147483647;position:fixed;left:0;top:0;');const v=e=>{'close-error-report'===e.data&&(p.remove(),t.removeEventListener('message',v))};t.addEventListener('message',v),document.body.appendChild(p);const w=()=>{const e=p.getBoundingClientRect();return'none'!==t.getComputedStyle(p).display&&0!==e.width&&0!==e.height},S=setInterval((()=>{if(!document.contains(p))return clearInterval(S);w()||(s(d),clearInterval(S))}),1e3);setTimeout((()=>{g||s(errStr)}),3e3)}catch(y){s(y)}}}();");
                script.setAttribute('onerror', "!async function(){const e=window,t=e.atob,r=e.btoa;let o=JSON.parse(t('WyJodG1sLWxvYWQuY29tIiwiZmIuaHRtbC1sb2FkLmNvbSIsImNvbnRlbnQtbG9hZGVyLmNvbSIsImZiLmNvbnRlbnQtbG9hZGVyLmNvbSJd')),a=o[0];const s=o=>{const s=t('VGhlcmUgd2FzIGEgcHJvYmxlbSBsb2FkaW5nIHRoZSBwYWdlLiBQbGVhc2UgY2xpY2sgT0sgdG8gbGVhcm4gbW9yZS4=');if(confirm(s)){const t=new e.URL('https://report.error-report.com/modal'),s=t.searchParams;s.set('url',r(location.href)),s.set('error',r(o.toString())),s.set('domain',a),location.href=t.href}else location.reload()};try{if(void 0===e.as_retry&&(e.as_retry=0),e.as_retry>=o.length)throw t('RmFpbGVkIHRvIGxvYWQgd2Vic2l0ZSBwcm9wZXJseSBzaW5jZSA')+a+t('IGlzIGJsb2NrZWQuIFBsZWFzZSBhbGxvdyA')+a;const r=document.querySelector('#YrblBvsA'),s=document.createElement('script');for(let e=0;e<r.attributes.length;e++)s.setAttribute(r.attributes[e].name,r.attributes[e].value);const n=new e.URL(r.getAttribute('src'));n.host=o[e.as_retry++],s.setAttribute('src',n.href),r.setAttribute('id',r.getAttribute('id')+'_'),r.parentNode.insertBefore(s,r),r.remove()}catch(t){console.error(t);try{e.localStorage.setItem(e.location.host+'_fa_'+r('last_bfa_at'),Date.now().toString())}catch(e){}try{setInterval((()=>document.querySelectorAll('link,style').forEach((e=>e.remove()))),100);const o=await(await fetch('https://error-report.com/report?type=loader_light&url='+r(location.href)+'&error='+r(t),{method:'POST'})).text();let n=!1;e.addEventListener('message',(e=>{'as_modal_loaded'===e.data&&(n=!0)}));let c=document.createElement('iframe');const i=new e.URL('https://report.error-report.com/modal'),l=i.searchParams;l.set('url',r(location.href)),l.set('eventId',o),l.set('error',r(t)),l.set('domain',a),c.src=i.href,c.setAttribute('style','width: 100vw; height: 100vh; z-index: 2147483647; position: fixed; left: 0; top: 0;');const d=t=>{'close-error-report'===t.data&&(c.remove(),e.removeEventListener('message',d))};e.addEventListener('message',d),document.body.appendChild(c);const m=()=>{const t=c.getBoundingClientRect();return'none'!==e.getComputedStyle(c).display&&0!==t.width&&0!==t.height},h=setInterval((()=>{if(!document.contains(c))return clearInterval(h);m()||(s(t),clearInterval(h))}),1e3);setTimeout((()=>{n||s(errStr)}),3e3)}catch(e){s(e)}}}();");
                document.head.appendChild(script);
              })();
            `,
          }}
        />
      )}
    </Head>
  )
}

export default DefaultHead
